import React from 'react';

// UI
import { XMarkIcon } from '@heroicons/react/24/outline';
import ReactPlayer from 'react-player';

// Types
export interface Props {
    url: string;
    onClose: () => void;
}

const VideoOverlay: React.FC<Props> = ({ onClose, url }) => {
    return (
        <div
            className="fixed left-0 top-0 z-[999] flex h-screen w-screen items-center justify-center bg-black/80"
            onClick={onClose}
        >
            <button className="absolute right-0 top-0 p-4">
                <XMarkIcon className="h-10 w-10 text-white" />
            </button>

            <div className="aspect-video w-full sm:w-3/4">
                <ReactPlayer url={url} width="100%" height="100%" playing />
            </div>
        </div>
    );
};

export default VideoOverlay;
